const dev = {
  dataBackend: 'http://localhost:4002/',
  serviceBackend: 'http://localhost:4001/',
  processingBackend: 'http://localhost:4000/',
};

const prod = {
  dataBackend: 'https://visionlab.wzl-iqs.rwth-aachen.de/visionlab-data/',
  serviceBackend: 'https://visionlab.wzl-iqs.rwth-aachen.de/visionlab-services/',
  processingBackend: 'https://visionlab.wzl-iqs.rwth-aachen.de/visionlab-backend/',
};

const config = process.env.REACT_APP_STAGE === 'prod' ? prod : dev;

export default config;
